import aboutRoutes from './about/about.routes';
import contactRoutes from './contact.routes';
import errorRoutes from './error.routes';
import forgotPasswordRoutes from './forgot-password.routes';
import helpRoutes from './help.routes';
import homeRoutes from './home.routes';
import loginRoutes from './login.routes';
import outboxRoutes from './outbox.routes';
import productsRoutes from './products.routes';
import searchRoutes from './search.routes';
import setPasswordRoutes from './set-password.routes';
import settingsRoutes from './settings.routes';
import signUpRoutes from './sign-up.routes';
import trainingRoutes from './training/training.routes';
import favoritesRoutes from './favorites.routes';

const routes = [
  ...aboutRoutes,
  ...contactRoutes,
  ...errorRoutes,
  ...forgotPasswordRoutes,
  ...helpRoutes,
  ...homeRoutes,
  ...loginRoutes,
  ...outboxRoutes,
  ...productsRoutes,
  ...searchRoutes,
  ...setPasswordRoutes,
  ...settingsRoutes,
  ...signUpRoutes,
  ...trainingRoutes,
  ...favoritesRoutes,
];

export default {
  routes,
};
